import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useRecommendedFacilities = () => {
  const client = useGyymClient()
  const { data, isValidating } = useGyymSWR(
    client.user.facilities.listRecommended,
  )

  return {
    facilities: data ? data : [],
    isValidating,
  }
}
